import React from 'react'
import cn from 'utils/tailwind/cn'

function TableItem({
  className,
  style,
  children,
  light,
  paddingVertical = 4,
  paddingHorizontal = 3,
  colSpan = 1,
}) {
  const textStyles = {
    'text-gray-500': light,
    'text-gray-900': !light,
  }
  return (
    <td
      className={cn(`px-${paddingHorizontal} py-${paddingVertical} border-b truncate border-gray-200 text-sm leading-5 font-medium`, textStyles, className)}
      {...{colSpan, style}}
    >
      {children}
    </td>
  )
}

export default TableItem
